import { Component, Input } from "@angular/core";
import { ErrorService } from "./error.service";
import { MultiError } from "./multi-error";
import { handleErrors } from "../misc/handle-errors.decorator";
import { NgSwitch } from "@angular/common";
import { ValidationError } from "./validation-error";
import { MultiValidationError } from "./multi-validation-error";
import { WorkbookMissingColumnsError } from "./workbook-missing-columns-error";
import { CDFValidationError } from "./cdf-validation-error";

type DisplayError = Error | MultiError | ValidationError | MultiValidationError | WorkbookMissingColumnsError |
  CDFValidationError;

@Component({
  selector: "error-display",
  templateUrl: "./error-display.template.pug",
  providers: [NgSwitch],
})
export class ErrorDisplayComponent {
  private _error: DisplayError;
  showError: boolean;
  multi: boolean = false;
  allowSelfAssign: boolean = false;
  selfAssignProjectId: string = "";
  errorMessageArray: string[] = [];
  multiError: boolean = false;
  errorSummary;
  errorDetails;
  IsParrtiallySuccess: boolean = false;
  billingTermsGuideLink: string;

  @Input()
  set error(error: DisplayError) {    
    this._error = error;
    if(error.message.includes('partially success')){
      this.IsParrtiallySuccess = true;
    }
    if (error.message.includes('errorSummary')) {
      let errmessage = error.message.split('|| errorSummary:');
      error.message = errmessage[0];
      let summary = JSON.parse(errmessage[1].trim());

      this.errorSummary = summary;//to display error in popup
      this.errorDetails = summary["Details"];

    } else if (error["Details"] && typeof (error["Details"]) == 'object') {
      this.errorSummary = error["Details"]; //to display error in popup
      this.errorDetails = error["Details"];
     } else if (typeof error.message === 'string' && error.message.includes('/n')) {
      const messages = error.message.split('/n').map(msg => msg.trim()); // Split by commas and trim whitespace
      this.errorMessageArray = messages; // Convert error.message to an array of messages
      this.multiError = true; // Set multiError to true
    } else if(Array.isArray(error)){
      let errmes='';
      error.forEach(err => {
        if (err["Details"] && typeof (err["Details"]) == 'object') {
          errmes+= '\\n' + err.Details.contextInformation.errorDetails; //to display error in popup
        }
      });
      error[0].Details.contextInformation.errorDetails=errmes;
      this.errorSummary = error[0]["Details"];
      this.errorDetails = error[0]["Details"];
    
    }
    this.multi = this.isMultiError();
    this.allowSelfAssign = this.error && this.error["projectId"] && this.error["allowSelfAssign"];
    this.selfAssignProjectId = this.error && this.error["projectId"] ? this.error["projectId"] : undefined;
  }

  @Input()
  set guideLink(link: string) {
    this.billingTermsGuideLink = link;
  }

  getCamelCaseWord(str) {
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); })
  }

  get error(): DisplayError {
    return this._error;
  }


  @Input() showPossibleResolution: any;

  static addError(self: ErrorDisplayComponent, error: Error) {
    if (!self.isMultiError()) {
      const tempError = new MultiError("");
      tempError.errors = [self.error];
      self.error = tempError;
    }

    const multiError = self.error as MultiError;

    if (!multiError.errors) multiError.errors = [];

    multiError.errors = [...multiError.errors, error];
  }

  constructor(private errorService: ErrorService) { }

  isMultiError() {
    return this.error && this.error instanceof MultiError;
  }

  @handleErrors({ errorProperty: "", scrollToTop: false, onError: ErrorDisplayComponent.addError as any })
  async assignMeToProject() {
    const assigned = await this.errorService.assignUserToProject(this.selfAssignProjectId);
    if (assigned) document.location.reload(true);
  }
}
